import { DOCUMENT, Location } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';

import { TermsDialogComponent } from 'auth/dialogs/terms-dialog/terms-dialog.component';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html'
})
export class FooterComponent {
  get isAdminUrl() {
    return this.location.path().toLowerCase().includes('/admin/');
  }

  constructor(
    private location: Location,
    private dialog: MatDialog,
    @Inject(DOCUMENT) private document: Document
  ) {
  }

  onShowTermsClick() {
    this.dialog.open(TermsDialogComponent);
  }

  hideFooter() {
    this.document.body.classList.remove('show-footer');
  }

}
